import type { PropsWithChildren } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { getSemesters } from '../data/semesters';
import { ISemester } from '../types/ICourse';
import { IApiContext } from '../types/Shared';
import { useAuthenticationContext } from './authenticationprovider';
export const SemesterContext = createContext<ISemesterContext>({ Pending: false, SetSelectedSemester: () => undefined });

export interface ISemesterContext extends IApiContext<ISemester[]> {
    SelectedSemester?: ISemester;
    SetSelectedSemester: (semester: ISemester) => void;
}

export function useSemesterContext() {
    return useContext(SemesterContext);
}

export function SemesterProvider({ children }: PropsWithChildren<{}>) {

    const [semesters, setSemesters] = useState<ISemester[]>();
    const [error, setError] = useState();
    const [pending, setPending] = useState(true);
    const [selectedSemster, setSelectedSemester] = useState<ISemester>();    
    const authContext = useAuthenticationContext();

    useEffect(() => {
        setError(undefined);
        setPending(true);
        if(authContext.Result && !authContext.Pending)
        {
            if(authContext.Result.IsAuthenticated)
            {
                getSemesters(authContext.Result).then(semesters => {                      
                    setSemesters(semesters);
                    if(semesters.length > 0)
                    {
                        setSelectedSemester(semesters[0]);
                    }
                }).catch(err => {
                    setError(err);
                }).finally(() => {
                    setPending(false);
                });
            }
        }
    }, [authContext]);
    return (
        <SemesterContext.Provider value={{ Error: error, Pending: pending, Result: semesters, SelectedSemester: selectedSemster, SetSelectedSemester: setSelectedSemester }}>
            {children}
        </SemesterContext.Provider>
    );
}